import { createRouter, createWebHistory } from "vue-router"
import store from "./modules"

import { auth } from './modules/auth.module'
import { eventBus } from "./event_bus"
import { useToast } from "bootstrap-vue-next"

export let router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            name: "pagenotfound",
            path: '/:pathMatch(.*)*',
            component: () => import('./views/PageNotFound.vue'),
            meta: {
                pageNotFound: true,
                allowAnonymous: true,
            },
        },
        {
            name: "accessdenied",
            path: "/accessdenied",
            component: () => import('./views/AccessDenied.vue'),
        },
        {
            name: "home",
            path: "/home",
            component: () => import('./views/Home.vue'),
        },
        {
            name: "root",
            path: "/",
            component: () => import('./views/Home.vue'),
            meta: {
                noPath: true,
            },
        },
        {
            name: "login",
            path: "/login",
            component: () => import('./views/auth/Login.vue'),
            meta: {
                allowAnonymous: true,
            },
        },
        {
            name: "webcodelogin",
            path: "/:webcode/login",
            component: () => import('./views/auth/Login.vue'),
            meta: {
                allowAnonymous: true,
            },
        },
        {
            name: "kiosk",
            path: "/kiosk/",
            component: () => import('./views/kiosks/Kiosk.vue'),
            meta: {
                hideNavMenu: true,
                authorized: "kiosks-r",
            }
        },
        {
            name: "kiosks",
            path: "/kiosks",
            component: () => import('./views/kiosks/Kiosks.vue'),
            meta: {
                authorized: "kiosks-r"
            }
        },
        {
            name: "transactions",
            path: "/transactions",
            component: () => import('./views/kiosks/Transactions.vue'),
            meta: {
                authorized: "transactions-r"
            }
        },
        {
            name: "products",
            path: "/products",
            component: () => import('./views/kiosks/Products.vue'),
            meta: {
                authorized: "products-r"
            }
        },
        {
            name: "prices",
            path: "/prices",
            component: () => import('./views/kiosks/Prices.vue'),
            meta: {
                authorized: "prices-r"
            }
        },
        {
            name: "refunds",
            path: "/refunds",
            component: () => import('./views/kiosks/Refunds.vue'),
            meta: {
                authorized: "refunds-r"
            }
        },
        {
            name: "sales",
            path: "/sales",
            component: () => import('./views/reports/Sales.vue'),
            meta: {
                authorized: "sales-r"
            }
        },
        {
            name: "kioskuptime",
            path: "/kioskUptime",
            component: () => import('./views/reports/KioskUptime.vue'),
            meta: {
                authorized: "uptime-r"
            }
        },
        {
            name: "regionuptime",
            path: "/regionUptime",
            component: () => import('./views/reports/RegionUptime.vue'),
            meta: {
                authorized: "uptime-r"
            }
        },
        {
            name: "commission",
            path: "/commission",
            component: () => import('./views/reports/Commission.vue'),
            meta: {
                authorized: "commission_report-r"
            }
        },
        {
            name: "codeactivity",
            path: "/codeactivity",
            component: () => import('./views/kiosks/CodeActivity.vue'),
            meta: {
                authorized: "code_activity-r"
            }
        },
        {
            name: "maintenancelogs",
            path: "/maintenancelogs",
            component: () => import('./views/kiosks/MaintenanceLogs.vue'),
            meta: {
                authorized: "maintenance_logs-r"
            }
        },
        {
            name: "events",
            path: "/events",
            component: () => import('./views/settings/Events.vue'),
            meta: {
                authorized: "events-r"
            }
        },
        {
            name: "users",
            path: "/users",
            component: () => import('./views/settings/Users.vue'),
            meta: {
                authorized: "user-r"
            }
        },
        {
            name: "apilogins",
            path: "/apilogins",
            component: () => import('./views/settings/ApiLogins.vue'),
            meta: {
                authorized: "api_login-r"
            }
        },
        {
            name: "roles",
            path: "/roles",
            component: () => import('./views/settings/Roles.vue'),
            meta: {
                authorized: "role-r"
            }
        },
        {
            name: "software",
            path: "/software",
            component: () => import('./views/firmware/Software.vue'),
            meta: {
                authorized: "software-r"
            }
        },
        {
            name: "assignment",
            path: "/assignment",
            component: () => import('./views/firmware/Assignment.vue')
        },
        {
            name: "release",
            path: "/release/:id",
            component: () => import('./views/firmware/Release.vue'),
            meta: {
                authorized: "phase-r"
            }
        },
        {
            name: "restoredata",
            path: "/restoreData",
            component: () => import('./views/kiosks/RestoreData.vue')
        },
        {
            name: "filearchivedata",
            path: "/fileArchiveData",
            component: () => import('./views/reports/FileArchiveData.vue'),
            meta: {
                authorized: "file_archive_data-r"
            }
        },
        {
            name: "enabletwofa",
            path: "/enabletwofa",
            component: () => import('./views/auth/EnableTwoFa.vue'),
            meta: {
                userWithoutTwoFaWhileRequired: true
            }
        },
        {
            name: "profile",
            path: "/profile",
            component: () => import('./views/account/Profile.vue'),
        },
        {
            name: "problems",
            path: "/problems",
            component: () => import('./views/fleet/Problems.vue'),
            meta: {
                authorized: "kiosks-r"
            }
        },
        {
            name: "firmware",
            path: "/firmware",
            component: () => import('./views/fleet/Firmware.vue'),
            meta: {
                authorized: "firmware-r"
            }
        },
        {
            name: "singleuse",
            path: "/singleuse",
            component: () => import('./views/promo/SingleUse.vue'),
            meta: {
                authorized: "promo_single-r"
            }
        },
        {
            name: "freeitem",
            path: "/freeitem",
            component: () => import('./views/promo/FreeItem.vue'),
            meta: {
                authorized: "promo_free-r"
            }
        },
        {
            name: "multipleuse",
            path: "/multipleuse",
            component: () => import('./views/promo/MultipleUse.vue'),
            meta: {
                authorized: "promo_multiple-r"
            }
        },
        {
            name: "reimbursement",
            path: "/reimbursement",
            component: () => import('./views/promo/Reimbursements.vue'),
            meta: {
                authorized: "promo_reimbursement-r"
            }
        },
        {
            name: "transactioncodes",
            path: "/transactioncodes",
            component: () => import('./views/promo/TransactionCodes.vue'),
            meta: {
                authorized: "promo_transactioncodes-r"
            }
        },
        {
            name: "promoprogram",
            path: "/promoprogram",
            component: () => import('./views/promo/PromoProgram.vue'),
            meta: {
                authorized: "promo_program-r"
            }
        },
        {
            name: "stores",
            path: "/stores/",
            component: () => import('./views/stores/Stores.vue'),
        },
        {
            name: "audit",
            path: "/audit",
            component: () => import('./views/settings/Audit.vue'),
            meta: {
                authorized: "audit-r"
            }
        },
        {
            name: "createaccount",
            path: "/createaccount/:tokenid",
            component: () => import('./views/auth/CreateAccount.vue'),
            meta: {
                allowAnonymous: true,
                createAccount: true
            }
        },
        {
            name: "createnewpassword",
            path: "/createnewpassword/:tokenid",
            component: () => import('./views/auth/CreateNewPassword.vue'),
            meta: {
                allowAnonymous: true,
                createNewPassword: true
            }
        },
        {
            name: "servants",
            path: "/servants",
            component: () => import('./views/kiosks/Servants.vue'),
            meta: {
                authorized: "servant-r"
            }
        },
        {
            name: "servant",
            path: "/servant",
            component: () => import('./views/kiosks/ServantDetails.vue'),
            meta: {
                authorized: "servant-r"
            }
        },
        {
            name: "customfields",
            path: "/customfields",
            component: () => import('./views/customfields/CustomFields.vue'),
            meta: {
                authorized: "custom_fields-r"
            }
        },
        {
            name: "regions",
            path: "/regions",
            component: () => import('./views/settings/Regions.vue'),
            meta: {
                authorized: "regions-r"
            }
        },
        {
            name: "portalconfig",
            path: "/portalconfig",
            component: () => import('./views/auth/PortalConfiguration.vue'),
            meta: {
                authorized: "portal_configuration-r"
            }
        },
        {
            name: "portalimages",
            path: "/portalimages",
            component: () => import('./views/auth/PortalImages.vue'),
            meta: {
                authorized: "portal_images-r"
            }
        }
    ],
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
});

router.beforeEach((to, from) => {

    if (to.hash !== ''){ //For SSO, to prevent router from killing popup redirect
        return;
    }

    if (eventBus) {
        eventBus.$emit("route_changed", to.path)
    }

    const authSecurity = auth.state.security
    const currentUser = auth.state.user

    var now = Date.now()
    if (currentUser) {
        if (authSecurity.jwt.exp - 300 < now / 1000 && authSecurity.jwt.exp > now / 1000) {
            store.dispatch("auth/refreshJwtToken")
        }

        if (authSecurity.requiresTwoFa && !authSecurity.hasTwoFaEnabled
            && (to.matched.some((record) => (record.meta.userWithoutTwoFaWhileRequired == undefined || record.meta.userWithoutTwoFaWhileRequired == false)))) {
            const {show} = useToast();
            show?.({props: {
                title: 'Error',
                variant: 'danger',
                solid: true,
                body: `Two factor authentication is a requirement of user's role`
            }});

            return { path: "/enabletwofa" }
        }
        else if (authSecurity.jwt.exp < now / 1000) {
            store.dispatch("auth/logout")
            return { path: "/login", query: { redirect_to: to.fullPath ?? from.fullPath } }
        }
        else if (to.matched.some((record) => !(record.meta.authorized == undefined || authSecurity.hasAccess(record.meta.authorized)))) {
            return { path: "/accessdenied", query: { redirect_to: from.fullPath } }
        }
        else if (to.matched.some((record) => record.meta.noPath)) {
            return { path: "/home" }
        }
        else if (to.matched.some((record) => record.meta.pageNotFound)) {
            return
        }
        else if (to.matched.some((record) => record.meta.createAccount)) {
            const {show} = useToast();
            show?.({props: {
                title: 'Error',
                variant: 'danger',
                solid: true,
                body: `Create account invite redirected. A user is already logged in`
            }});
            return { path: "/home" }
        }
        else if (to.matched.some((record) => record.meta.allowAnonymous)) {
            return { path: "/home" }
        }
        else {
            return 
        }
    }
    else {
        if (to.matched.some((record) => record.meta.noPath)) {
            return { path: "/login", query: { redirect_to: to.query.redirect_to ?? to.fullPath } }
        }
        else if (to.matched.some((record) => !record.meta.allowAnonymous)) {
            return { path: "/login", query: { redirect_to: to.query.redirect_to ?? to.fullPath } }
        }
        else {
            return 
        }
    }
});